import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  CLIENT_TTL_ES,
  IClient,
  IClientTable
} from '../../interfaces/client.interface';
import { ClientService } from '../../client.service';
import { IDENTIFIER_ID } from '../../interfaces/tercero.interface';

@Component({
  selector: 'pg-client-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ClientsSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ClientService) {
    super(CLIENT_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: CLIENT_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'name' },
        { header: 'Tipo de documento', field: 'identifier' },
        { header: 'N° de documento', field: 'idNumber' },
        { header: 'Direccion', field: 'address' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IClient[]) => {
        this.parseToTable(data);
      });
  }

  parseToTable(dataService) {
    const dataTable: IClientTable[] = dataService.map((item) => {
      return {
        ...item,
        identifier: IDENTIFIER_ID[item.identifierId]
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
